"use strict";
// These constants are used by tracking events across the application
// They are defined here in the models package to avoid circular dependencies
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingEventActionsForCopilotDatasheetImport = exports.trackingEventActionsForCopilotCredits = exports.trackingEventNewProjectDialog = exports.trackingEventCopilotCredits = exports.trackingEventCopilot = exports.trackingEventOrganizations = void 0;
exports.trackingEventOrganizations = "organizations";
exports.trackingEventCopilot = "copilot";
exports.trackingEventCopilotCredits = "copilot_credits";
exports.trackingEventNewProjectDialog = "new_project_dialog";
/**
 * These are the valid actions for the trackingEventCopilotCredits event
 *
 * Use e.g. keyof typeof trackingActionsForCopilotCredits when typing against this
 */
exports.trackingEventActionsForCopilotCredits = {
    // Backend actions
    outOfCreditResponse: "outOfCreditResponse",
    noCreditAccountAccess: "noCreditAccountAccess",
    creditUsed: "creditUsed",
    setSpendingLimit: "setSpendingLimit",
    // Frontend actions
    clickLearnMore: "clickLearnMore",
    clickSignUp: "clickSignUp",
    clickUpgrade: "clickUpgrade",
    clickRaiseLimit: "clickRaiseLimit",
    clickContactEnterpriseSales: "clickContactEnterpriseSales",
    shownPaidFirstTimeDialog: "shownPaidFirstTimeDialog",
    acceptedPaidFirstTimeDialog: "acceptedPaidFirstTimeDialog",
    clickAdjustLimitPaidFirstTimeDialog: "clickAdjustLimitPaidFirstTimeDialog",
};
/**
 * Actions for the trackingEventCopilotDatasheetImport event
 */
exports.trackingEventActionsForCopilotDatasheetImport = {
    // Backend actions
    importableComponentScanSuccess: "importableComponentScanSuccess",
    importComponentSuccess: "importComponentSuccess",
};
//# sourceMappingURL=trackingEventConstants.js.map